
































































import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {FORMAT_DATE_TIME_PICKER} from "@/shared/constant";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import {LadingStore} from "@/modules/ladings/store";
import moment from "moment";
import {numberToWord} from "@/shared/services/helper/number-to-vn";
@Component({
    name: "ManageLadingExcel",
    components: {TooltipLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly fromDate!: string;
    @Prop() readonly toDate!: string;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;
    moment = moment;
    numberToWord = numberToWord;
    get billLadings(): Array<any> {
        return LadingStore.ladingDataExcel;
    }

    // get totalMoney() {
    //     return this.billLadings.reduce((previousValue, currentValue: any) => {
    //         return previousValue + currentValue.totalFee;
    //     }, 0);
    // }
}
